import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import zh from './locales/zh.json';
import ro from './locales/ro.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import es from './locales/es.json';

// Define the resources
const resources = {
  en: { translation: en },
  zh: { translation: zh },
  ro: { translation: ro },
  de: { translation: de },
  fr: { translation: fr },
  es: { translation: es },
};

// Initialize i18next
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en', // fallback language if translation key is missing
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false, // disable suspense to avoid loading issues
    },
  });

export default i18n;
